import {createDivIn} from '../../ui_utils/DomUtils'

export class UIGameFeed {
    container: HTMLDivElement
    mainBlock: HTMLDivElement

    constructor(containerId: string, mainBlockClass?: string, containerClass?: string) {
        this.mainBlock = createDivIn(document.body, 'main_block ' + (mainBlockClass || ''))
        this.container = createDivIn(this.mainBlock, 'game_chat_text_div ' + (containerClass || ''), containerId)
        this.mainBlock.style.position = 'absolute'
    }

    scale(zoom: number) {
        this.mainBlock.style.transform = `scale(${zoom})`
    }

    setWidth(width: number) {
        this.container.style.width = width + 'px'
    }

    setHeight(height: number) {
        this.container.style.height = height + 'px'
    }

    setPositionLeft(offset: number) {
        this.mainBlock.style.left = offset + 'px'
    }

    setPositionRight(offset: number) {
        this.mainBlock.style.right = offset + 'px'
    }

    setPositionTop(offset: number) {
        this.mainBlock.style.top = offset + 'px'
    }

    setPositionBottom(offset: number) {
        this.mainBlock.style.bottom = offset + 'px'
    }

    setVisibility(visible: boolean) {
        this.mainBlock.style.visibility = visible ? 'visible' : 'hidden'
    }

    setFullWidth() {
        this.mainBlock.style.width = '100%'
    }
}
